export const EDIT_ORDER = 41;
export const EDIT_ORDER_TRACKING = 42;

export const VIEW_CORPORATIONS = 1;
export const CREATE_CORPORATION = 2;
export const EDIT_CORPORATION = 3;
export const DELETE_CORPORATION = 4;

export const VIEW_COMMUNITIES = 5;
export const CREATE_COMMUNITY = 6;
export const EDIT_COMMUNITY = 7;
export const DELETE_COMMUNITY = 8;

export const VIEW_USERS = 9;
export const CREATE_USER = 10;
export const EDIT_USER = 11;
export const DELETE_USER = 12;

export const VIEW_PENDING_ORDERS = 13;
export const CHECK_ORDER_STATUS = 14;
export const UNCHECK_ORDER_STATUS = 15;
export const EDIT_ORDER_CLIENT_CONTENT = 16;
export const VIEW_ORDER_DETAILS = 17;
export const VIEW_INVOICE = 18;
export const EDIT_INVOICE = 19;
export const CHECK_HUB_ORDER_STATUS = 20;
export const UNCHECK_HUB_ORDER_STATUS = 21;
export const VIEW_CLOSED_ORDERS = 22;
export const MARK_INVOICE_AS_PAID = 23;

export const VIEW_FILLER_ARTICLES = 24;
export const UPDATE_FILLER_ARTICLES = 25;
export const DELETE_FILLER_ARTICLES = 26;

export const VIEW_THEMES = 27;
export const CREATE_THEME = 28;
export const EDIT_THEME = 29;
export const DELETE_THEME = 40;

export const VIEW_PRICING = 30;
export const EDIT_PRICING = 31;

export const VIEW_EARLY_BIRD = 32;
export const EDIT_EARLY_BIRD = 33;

export const VIEW_SHIPPING = 34;
export const EDIT_SHIPPING = 35;

export const VIEW_SAGE = 36;
export const EDIT_SAGE = 37;

export const VIEW_NOTIFICATIONS = 38;
export const EDIT_NOTIFICATIONS = 39;

export const VIEW_HOLIDAY = 43;

export const VIEW_DD_BACKGROUND = 47;
export const CREATE_DD_BACKGROUND = 48;
export const EDIT_DD_BACKGROUND = 49;
export const DELETE_DD_BACKGROUND = 50;
export const COMMUNITY_LOGS = 51;

export const UPDATE_INVOICED_ORDER_STATUS = 52;
export const UPDATE_PDF_APPROVED_STATUS = 53;

export const SET_BILLABLE_EDIT = 54;
export const OVERRIDE_ORDER_STATUS = 55;
export const EDIT_ORDER_QUANTITY = 56;

export const CREATE_CALENDAR = 57;
export const EDIT_CALENDAR = 58;
export const CREATE_NEWSLETTER = 59;
export const EDIT_NEWSLETTER = 60;
export const DOWNLOAD_ORDER_ITEMS = 61;
